import { render, staticRenderFns } from "./vehicleCertification.vue?vue&type=template&id=68c4c83a&scoped=true"
import script from "./vehicleCertification.vue?vue&type=script&lang=js"
export * from "./vehicleCertification.vue?vue&type=script&lang=js"
import style0 from "./vehicleCertification.vue?vue&type=style&index=0&id=68c4c83a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c4c83a",
  null
  
)

export default component.exports